import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { AgeSurchargeType } from "@/gql/graphql";

export function AgeSurchargeTypeInput(
  props: Omit<SelectInputProps<any>, "options">,
) {
  const options: {
    [key in AgeSurchargeType]: {
      label: string;
      value: AgeSurchargeType;
    };
  } = {
    [AgeSurchargeType.FlatFee]: {
      label: "Flat Fee",
      value: AgeSurchargeType.FlatFee,
    },
    [AgeSurchargeType.PerDay]: {
      label: "Per Day",
      value: AgeSurchargeType.PerDay,
    },
    [AgeSurchargeType.Unspecified]: {
      label: "Unspecified",
      value: AgeSurchargeType.Unspecified,
    },
  };

  return (
    <SelectInput
      options={[
        {
          label: "Surcharge Type",
          options: [
            options[AgeSurchargeType.FlatFee],
            options[AgeSurchargeType.PerDay],
            options[AgeSurchargeType.Unspecified],
          ],
        },
      ]}
      {...props}
    />
  );
}
